export default __webpack_public_path__ + "static/media/instruction-title-1.3fa33121.png";